const clientId =
  process.env.REACT_APP_MSAL_CLIENT_ID || 'aa63caaf-2a95-4a32-82cc-937622a00057'

const tenantId = process.env.REACT_APP_MSAL_TENANT_ID || 'organizations'

const authority = `https://login.microsoftonline.com/${tenantId}`

const redirectUri =
  process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin

export const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
}

export const loginRequest = {
  scopes: ['api://b05ef45d-5a41-4aee-85e4-ad460ca91187/access_as_user']
}
